var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDownArrowLight(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 24,
    viewBox: "0 0 45 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44.9583 4.62881C44.9599 5.10812 44.8541 5.5817 44.6487 6.01476C44.4433 6.44782 44.1434 6.82935 43.7712 7.13131L24.5212 22.6276C23.9471 23.0995 23.227 23.3574 22.4839 23.3574C21.7408 23.3574 21.0207 23.0995 20.4466 22.6276L1.19661 6.5859C0.54142 6.04132 0.129391 5.25877 0.0511729 4.4104C-0.0270454 3.56203 0.234953 2.71734 0.779531 2.06215C1.32411 1.40695 2.10666 0.994923 2.95503 0.916704C3.80339 0.838487 4.64809 1.10048 5.30328 1.64506L22.5 15.9863L39.6966 2.12631C40.1676 1.73399 40.741 1.48477 41.3491 1.40816C41.9573 1.33154 42.5746 1.43074 43.1282 1.694C43.6817 1.95726 44.1482 2.37358 44.4726 2.89368C44.7969 3.41378 44.9654 4.01591 44.9583 4.62881Z",
    fill: "#F0F0EE"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownArrowLight);
export default __webpack_public_path__ + "static/media/down_arrow_light.247e3279af1f1e1e2b780ba0f42639ac.svg";
export { ForwardRef as ReactComponent };